module.exports = __webpack_public_path__ + "static/media/twitter-container-nick.b724c690.svg";